<template>
  <h1 class="inner light">
    <router-link :to="{name: 'Hall', params: {slug: $store.getters['event/slug'], hallSlug: defaultHall.slug}}">
      {{ $store.getters["event/event"].name }}
    </router-link>
  </h1>
</template>

<script>
export default {
  name: "Title",
  props: {
    defaultHall: {
      type: Object,
      required: true
    }
  }
}
</script>
